export { default as Messaging } from './components/pages/Messaging';

export const MessagingDynamic = () => import('./components/pages/Messaging');

export { AIMessageModalProvider, useAIMessageModal } from './components/AIMessageModal';
export type {
  AIMessageDraft,
  AIMessageModalApi,
  AIMessageScreen,
  AutoSendCadence,
  MessageRewriteAction,
  OpenAIMessageModalInput,
} from './components/AIMessageModal';
export { AI_MESSAGE_ACTIONS } from './utils/aiMessageActions';
export type { AIMessageAction, AIMessageActionKey } from './utils/aiMessageActions';
